module.exports = __webpack_public_path__ + "media/images/paper_plane-c5e5c87a.svg";